// extracted by mini-css-extract-plugin
export default {"kycPage":"kyc_kycPage__aaex1","appHeader":"kyc_appHeader__v201z","header":"kyc_header__mXKkW","body":"kyc_body__YajLM","loading":"kyc_loading__kfgI8"};